export enum Pathname {
  INSIGHTS = 'insights',
  FATIGUE_MANAGER = 'fatigue-manager',
  SETTINGS = 'settings',
  COMMAND_CENTER = 'command-center',
}
